import React from "react";
import { ReactComponent as BitCoin } from "../../../../../assets/images/bitcoin-icon.svg";
import { formatCoin, renderPercent } from "../../../../../utils/utils";
import useDeviceDetect from "../../../../../hook/useDeviceDetect";
export default function LockPrice(props: any) {
  const { lockPrice, lang } = props;

  const { isTablet } = useDeviceDetect();

  return (
    <div
      className={`wrap-item wrap-item-lock-price
    animate__animated
    ${
      isTablet
        ? "animate__zoomIn animate-delay-03"
        : "animate__fadeInRight animate-delay-03"
    }
    `}
    >
      <div className="icon-bit-coin">
        <BitCoin />
      </div>
      <p className="label-lock-price">{lang?.locked_price || "Locked Price"}</p>
      <div className="wrap-lock-price">
        <span className="syb">$</span>
        <span className="value">{formatCoin(lockPrice, 0)}.</span>
        <span className="percent">{renderPercent(lockPrice)}</span>
      </div>
    </div>
  );
}
